export default {"src":"/_next/static/media/dots.fbd85fc3.svg","height":763,"width":184,"blurWidth":0,"blurHeight":0};